module.exports = __webpack_public_path__ + "static/img/ic_hidden_short.ce3027e2.svg";